<div class="text-ss-brown mx-8 md:mx-32">
  <div class="flex flex-col md:flex-row justify-between">
    <h2
      [ssDirectus]="{
        collection: collectionName(),
        item: assetListContent().id,
        fields: ['title', 'categories'],
      }"
    >
      {{ assetListContent().title }}
    </h2>
    <ss-button
      buttonColor="accent"
      buttonStyle="outlined"
      (click)="downloadAllClicked()"
      (keydown.enter)="downloadAllClicked()"
      >Download All</ss-button
    >
  </div>
  <div class="my-10">
    @for (category of assetListContent().categories; track category.id) {
      @if (category.view === 'list') {
        <div
          [ssDirectus]="{
            collection: categoryCollectionName(),
            item: category.id,
            fields: ['title', 'view', 'assets'],
          }"
        >
          <h3>{{ category.title }}</h3>
          <hr class="border-ss-brown opacity-30" />
          @for (asset of category.assets; track asset.directus_files_id.id) {
            <div
              class="flex bg-ss-lightest-grey p-4 rounded-2xl flex-col md:flex-row items-center justify-between gap-5 mt-6"
            >
              <div class="w-36">
                @if (asset.directus_files_id.type?.includes('image')) {
                  @if (asset.directus_files_id) {
                    <ss-www-image-with-loader
                      class="relative aspect-[4/3] md:aspect-video"
                      [fileDetail]="asset.directus_files_id"
                      desktopImageSize="half"
                      [isGallery]="true"
                      [isDownloadable]="true"
                    >
                    </ss-www-image-with-loader>
                  }
                } @else {
                  @if (asset.directus_files_id) {
                    <ss-www-image-with-loader
                      class="relative aspect-[4/3] md:aspect-video"
                      [fileDetail]="
                        asset.directus_files_id.customThumbnail ??
                        defaultThumbnail()
                      "
                      [previewNonImageDetail]="asset.directus_files_id"
                      desktopImageSize="half"
                      [isGallery]="true"
                      [isDownloadable]="true"
                    >
                    </ss-www-image-with-loader>
                  }
                }
              </div>
              <div class="flex flex-col md:w-2/5 md:ml-10">
                @if (asset.directus_files_id.title) {
                  <h4>{{ asset.directus_files_id.title }}</h4>
                }
              </div>
              <div class="flex flex-row w-full md:w-1/3 justify-between">
                <div>
                  <h4>
                    {{ +(asset.directus_files_id.filesize ?? 0) | fileSize }}
                  </h4>
                </div>
                <div>
                  <a
                    href="{{ assetsBaseUrl }}/{{
                      asset.directus_files_id.id
                    }}?download={{ asset.directus_files_id.filename_download }}"
                    target="_blank"
                    [download]="asset.directus_files_id.filename_download"
                    ><ss-button
                      class="download-link-button"
                      buttonColor="accent"
                      buttonStyle="filled"
                      >Download</ss-button
                    ></a
                  >
                </div>
              </div>
            </div>
          }
        </div>
      } @else {
        <div
          class="mt-10"
          [ssDirectus]="{
            collection: categoryCollectionName(),
            item: category.id,
            fields: ['title', 'view', 'assets'],
          }"
        >
          <h3>{{ category.title }}</h3>
          <hr class="border-ss-brown opacity-30 mb-6" />
          <div
            class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5"
          >
            @for (asset of category.assets; track asset.directus_files_id.id) {
              <div class="flex flex-col items-center justify-between">
                <div class="w-64">
                  @if (asset.directus_files_id.type?.includes('image')) {
                    @if (asset.directus_files_id) {
                      <ss-www-image-with-loader
                        class="relative rounded-xl aspect-[4/3] md:aspect-video"
                        [fileDetail]="asset.directus_files_id"
                        desktopImageSize="half"
                        [isGallery]="true"
                        [isDownloadable]="true"
                      >
                      </ss-www-image-with-loader>
                    }
                  } @else {
                    @if (asset.directus_files_id) {
                      <ss-www-image-with-loader
                        class="relative rounded-xl aspect-[4/3] md:aspect-video"
                        [fileDetail]="
                          asset.directus_files_id.customThumbnail ??
                          defaultThumbnail()
                        "
                        [previewNonImageDetail]="asset.directus_files_id"
                        desktopImageSize="half"
                        [isGallery]="true"
                        [isDownloadable]="true"
                      >
                      </ss-www-image-with-loader>
                    }
                  }
                </div>
                <p class="max-w-[256px] text-xl">
                  {{ asset.directus_files_id.title }}
                </p>
                <div
                  class="flex flex-row mt-8 justify-between w-full max-w-[256px]"
                >
                  <h4>
                    {{ +(asset.directus_files_id.filesize ?? 0) | fileSize }}
                  </h4>
                  <a
                    href="{{ assetsBaseUrl }}/{{
                      asset.directus_files_id.id
                    }}?download={{ asset.directus_files_id.filename_download }}"
                    target="_blank"
                    [download]="asset.directus_files_id.filename_download"
                    ><ss-button
                      class="download-link-button"
                      buttonColor="accent"
                      buttonStyle="filled"
                      >Download</ss-button
                    ></a
                  >
                </div>
              </div>
            }
          </div>
        </div>
      }
    }
  </div>
</div>
